import { CardInputWithType, ECardType } from '__generated__/globalTypes';
import * as DOMPurify from 'dompurify';
import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';

const removeHtmlTags = (text: string) =>
    DOMPurify.sanitize(text, { FORBID_TAGS: ['style', 'img', 'style', 'script'] });

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    const cards: CardInputWithType[] = [];

    const links = [];

    if (row['websiteURL']) {
        links.push({
            title: 'Website',
            url: row['websiteURL']
        });
    }

    if (row['bookingURL']) {
        links.push({
            title: 'Booking',
            url: row['bookingURL']
        });
    }

    if (links?.length > 0) {
        cards.push({
            type: ECardType.LINK,
            links
        });
    }

    if (row['phoneNumber']) {
        cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'Kontakt',
                description: `**Telefon:** ${row['phoneNumber']}`
            }
        });
    }

    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row['sourceUrl'],
            header: {
                title: row['title'],
                text: removeHtmlTags(row['description']),
                imageUrl: row['imageUrl'],
                imageStyleId: 'stretch'
            }
        },
        cards: cards
    };

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return (
        story.importKey &&
        story.importKey.trim().toLowerCase() === row['sourceUrl']?.trim().toLowerCase()
    );
}

export const seafoodCompaniesImportMethods = { duplicateChecker, parser };
